import { render, staticRenderFns } from "./Terms.vue?vue&type=template&id=11da1cb5&scoped=true&"
import script from "./Terms.vue?vue&type=script&lang=js&"
export * from "./Terms.vue?vue&type=script&lang=js&"
import style0 from "./Terms.vue?vue&type=style&index=0&id=11da1cb5&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "11da1cb5",
  null
  
)

export default component.exports